<template>
  <div>
    <div class="row" v-if="tasks">
      Found <strong>{{ tasks.length }}</strong> results
    </div>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Task</th>
        <th>Order</th>
        <th>Pbn</th>
        <th>Pbn Client</th>
        <th>Pbn Group</th>
        <th>Type</th>
        <th>Added</th>
        <th>By</th>
        <th>Assignee</th>
        <th>Status</th>
        <th>Updated</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="task in tasks" :key="task.id" :class="'task-' + task.status + (task.blocker ? ' task-blocked' : '')">
        <td>
          <i class="fa fa-check green" title="Completed" v-if="task.status === 'completed'"></i>
          <i class="fa fa-clock orange" title="Waiting" v-if="task.status === 'created'"></i>
          <i class="fas fa-user-cog orange" title="Assigned" v-if="task.status === 'assigned'"></i>
          <i class="fa fa-check grey" title="Closed" v-if="task.status === 'closed'"></i>
          <span :class="'m-l-xs m-r-xs label label-' + (task.priority === '1' ? 'default' : (task.priority === '2' ? 'info' : 'danger'))">
            <i class="fa fa-tasks"></i>
          </span>
          <i class="fa fa-ban red" v-if="task.blocker" :title="task.blocker.type + ' - ' + task.blocker.message"></i>
          <router-link :to="'/maintenance/task/' + task.id">{{ task.title }}</router-link>
          <span v-if="task.description"><i class="fa fa-comment" :title="task.description"></i></span>
          <div v-if="task.tags" class="m-t-xs">
            <span v-for="(tag, i) in task.tags" :key="task.id + '-tag-' + i" class="label label-info m-r-xs">{{ tag }}</span>
          </div>
        </td>
        <td>{{ task.order ? task.order.name : '/' }}</td>
        <td>{{ task.pbn.domain }}</td>
        <td>{{ task.pbn.client.name }}</td>
        <td>{{ task.pbn.group ? task.pbn.group.name : '/' }}</td>
        <td>{{ task.type }}</td>
        <td>{{ task.created | aTime('from') }}</td>
        <td>{{ task.creator ? task.creator.name : 'system' }}</td>
        <td>{{ task.assignee ? task.assignee.name : '/' }}</td>
        <td>{{ task.status }}</td>
        <td>
          <span v-if="task.updated && task.updated.date" :title="task.updated.date">
            {{ task.updated | aTime('from') }}
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      tasks: 'getTasks'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Tasks/List.vue